import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Separator,
  Button,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import classnames from 'classnames';
import ModalMessage from '@components/UI/organisms/ModalMessage';
import LoadingMessage from '@components/UI/organisms/AppLoadingMessage';
import { TutorCards } from './tutor-cards.component';
import type { ShowTutorsOnSlotModalProps } from './show-tutors-on-slot-modal.types';

export const ShowTutorsOnSlotModal = ({
  isLoading,
  isSaving,
  tutors,
  lessonDate,
  lessonTime,
  message,
  messageType,
  onBookTutor,
  onClose,
}: ShowTutorsOnSlotModalProps) => {
  const { t } = useTranslation('common');

  const wrapperClass = classnames('max-w-md mx-auto', {
    loading: isLoading || isSaving,
  });

  const loadingMessage = isSaving ? t('general.processing') : null;
  const loadingClass = 'modal-loading-message';

  const renderTutorCards = () => {
    if (isLoading) {
      return <div style={{ height: '200px' }} />;
    }

    if (tutors.length === 0) {
      return (
        <div style={{ height: '200px' }}>
          <p>There are no available tutors. Please choose another timeslot.</p>
        </div>
      );
    }

    return <TutorCards tutors={tutors} onBookTutor={onBookTutor} />;
  };

  return (
    <div className={wrapperClass}>
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>
            {lessonDate} {lessonTime}
          </CardTitle>
          <button type="button" className="modal-close" onClick={onClose}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <LoadingMessage message={loadingMessage} loadingClass={loadingClass} />
          <ModalMessage message={message} messageType={messageType} />
          <div>
            <div className="tutor-cards-container">{renderTutorCards()}</div>
          </div>
          <Separator className="my-4" />
          <div className="control-group text-right">
            <Button variant="outline" disabled={isSaving} onClick={onClose}>
              {t('links.cancel')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
